module.exports = __webpack_public_path__ + "fonts/KFOmCnqEu92Fr1Mu7WxKOzY.52cebac.woff2";